import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
    import CheckBoxInputListWithOneSelect from '@ve/components/inputs/CheckBoxInputListWithOneSelect.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
    import { HotelCategoryForFilter } from '@ve/components/filters/hotelCategoriesFilter/common/types';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';

    import useVueProxy from '@ve/services/useVueProxy';
    import { useState } from 'vuex-composition-helpers';
    import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
    import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
    import FilterStars from '../common/FilterStars.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelCategoriesFilterList',
  props: {
    categoriesList: { default: () => [] }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({(e: 'change', value: IMapForFiltersSerpState['hotelCategories']): void;}), expose: any, slots: any, attrs: any }) {

    

    

    const { $root } = useVueProxy();

    const {
        hotelCategories,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['hotelCategories']);

    const selected = computed({
        get: () => unref(hotelCategories),
        set: (value) => {
            emit('change', value);
            $root?.$emit('hotel-categories-filter-changed', value);
        },
    });

    const allChecked = computed({
        get: () => !unref(selected).length,
        set: (value) => {
            if (value) {
                selected.value = [];
            }
        },
    });

return { __sfc: true,emit, $root, hotelCategories, selected, allChecked, CheckBoxInputListWithOneSelect, CheckBoxInput, FilterListItem, TextCommon, FilterStars }
}

})